import { FC } from 'react';

import type { FAQPage } from 'schema-dts';

export interface IFAQ {
  question: string;
  answer: string;
}

interface IFAQSchemaProps {
  faqs: IFAQ[];
}

export const FAQSchema: FC<IFAQSchemaProps> = ({ faqs }) => {
  const schemaFaq: FAQPage = {
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => {
      return {
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      };
    }),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schemaFaq, null, 2),
      }}
    />
  );
};
